import script from "./RandomNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./RandomNumber.vue?vue&type=script&setup=true&lang=js"

import "./RandomNumber.vue?vue&type=style&index=0&id=76919a2e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76919a2e"]])

export default __exports__